// One-Time vs Weekly order radio buttons on the full cart page. Persists the
// choice to the session immediately (no page reload) so it's picked up by
// CheckoutController#create whenever the shopper proceeds to checkout.

document.addEventListener('change', function (event) {
  var radio = event.target.closest('.js-order-type-toggle input[type="radio"]')
  if (!radio) return

  var meta = document.querySelector('meta[name="csrf-token"]')
  var token = meta ? meta.content : ''

  fetch('/cart/order_type', {
    method: 'PATCH',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-CSRF-Token': token,
      Accept: 'application/json'
    },
    body: 'order_type=' + encodeURIComponent(radio.dataset.orderType)
  }).catch(function () {
    // Network hiccup: the choice will still be re-applied on next page load
    // once the request succeeds, so no reload is needed here.
  })
})
